import React from "react";
import { compose } from "recompose";
import { FormattedMessage, useIntl } from "react-intl";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { ReportForm } from "@reports/components/ReportForm";
import { Card, CardBody, Page, PageTitle } from "@ui/Page";

type Props = RouteComponentProps<any>;

const breadcrumbItems = [
    {
        text: <FormattedMessage {...messages.pageReportsTitle} />,
        to: "/reports",
    },
    {
        text: <FormattedMessage {...messages.pageReportsCreateTitle} />,
    },
];

const ReportsCreate = ({ history }: Props) => {
    const intl = useIntl();
    return (
        <Page className="reports-create-page" breadcrumbs={breadcrumbItems}>
            <PageTitle tag="h1" className="display-2">
                <FormattedMessage {...messages.pageReportsCreateTitle} />
            </PageTitle>
            <Card>
                <CardBody>
                    <ReportForm intl={intl} onSuccess={() => { history.push("/reports"); }} />
                </CardBody>
            </Card>
        </Page>
    );
};

const ConnectedReportsCreate = compose<Props, {}>(
    setTitleOnPage(
        messages.pageReportsTitle, messages.pageReportsCreateTitle,
    ),
    withRouter,
)(ReportsCreate);

export {
    ReportsCreate as ReportsCreatePresenter,
    ConnectedReportsCreate as ReportsCreate,
};
